import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "trigger"];

  copy(event) {
    event.preventDefault();
    if (!this.hasSourceTarget) return;

    const trigger = this.hasTriggerTarget ? this.triggerTarget : event.currentTarget;
    const originalNodes = Array.from(trigger.childNodes).map(n => n.cloneNode(true));

    const restoreOriginal = () => {
      trigger.replaceChildren(...originalNodes);
    };

    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      trigger.textContent = "";
      trigger.insertAdjacentHTML("afterbegin", '<i class="fas fa-check"></i>');
      setTimeout(restoreOriginal, 1500);
    }).catch(() => {
      trigger.textContent = "";
      trigger.insertAdjacentHTML("afterbegin", '<i class="fas fa-times"></i>');
      setTimeout(restoreOriginal, 1500);
    });
  }
}
